<template>
  <div class="box" @click="chooseSn(item.sn, item.state, item.deviceType, item.runMode)">
    <div
      class="device-header"
      :class="
        item.state
          ? Object.keys(flickerDict).includes(item.state.toString())
            ? flickerDict[item.state]
            : ''
          : ''
      "
      :id="item.id"
      :style="{
        '--bgcolor': getState(item.runstate, item.state).c2
      }"
    >
      <div class="icon-warp">
        <i :class="item.icon"></i>
      </div>
      <el-tooltip class="item" effect="dark" :content="item.showName" placement="top-start">
        <span class="text-ellipsis">{{ item.showName }}</span>
      </el-tooltip>
    </div>
    <div class="device-container">
      <img :src="item.imgSrc" alt="" />
      <div class="device-text">
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.dynamicInfoMap.location_desc"
          placement="top-start"
        >
          <span
            :style="{
              color: item.state == -1 ? 'rgba(159, 159, 159, 0.5)' : '#fff'
            }"
            class="text-ellipsis"
          >
            {{ item.dynamicInfoMap.location_desc }}
          </span>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import ctt from '@/utils/const';
import { pointState } from '@/utils/dict';
import { getOptions } from '@/utils/deviceUtils/state';

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      flickerDict: {
        1: 'early-alarm',
        2: 'pulse-alarm',
        3: 'pulse-alarm'
      }
    };
  },
  methods: {
    getState(runstate, state) {
      return getOptions(runstate, state);
    },
    chooseSn(sn, state, deviceType, runMode) {
      if (
        runMode === ctt.MONITOR_DEVICE &&
        (state === undefined || state === ctt.POINT_STATE_UNCONNECT)
      ) {
        this.$message({ type: 'info', message: pointState[state] });
      } else {
        if (sn !== this.$route.params.sn) {
          this.$router.push({
            name: 'Realdata',
            params: { sn, deviceType }
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  .device-header {
    background: var(--bgcolor) !important;
    padding-left: 0 !important;
    display: flex;
    align-items: center;

    .icon-warp {
      position: relative;
      --color: #c4c4c4;
      --size: 30px;
      --base-size: 28px;
      width: var(--size);
      height: var(--size);
      border: 3px solid var(--color);
      border-radius: 50%;
      background-color: var(--bg-color);
      margin: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      .iconfont {
        margin: 0 10px;
        font-size: 25px !important;
      }
      .air-icon-text {
        font-size: 36px;
        font-weight: bold;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 100%;
          height: 5px;
          background: var(--color);
          transform: translateY(-50%) rotate(45deg);
        }
      }
    }
  }
}
</style>
